import styles from '../OngoingLoanView.module.css';
import OrderSummary from '../../../../orderSummary/OrderSummary';
import RepayRequest from './RepayRequest';
import { OngoingPaymentPlan } from '../../../Dashboard.types';

const OverdueView = ({
    paymentPlan: { account, interestRate, principle }
}: {
    paymentPlan: OngoingPaymentPlan;
}) => {
    return (
        <div className={styles.OngoingView}>
            <div className={styles.orderSection}>
                <div className={styles.repaymentWrapper}>
                    <RepayRequest account={account} />
                </div>

                <OrderSummary
                    orderAmount={principle}
                    interestRate={interestRate}
                    account={account}
                    title={null}
                />
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default OverdueView;
